// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-image"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 22H20V8H14V2H4V22Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14 2V8H20M14 2H4V22H20V8M14 2H15L20 7V8","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8.62207 16.9995L9.0634 16.5582L10.5442 15.1262L11.1842 15.8962L12.728 14.3516L15.3759 16.9995M9 12H9.00391V12.0039H9V12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileImageIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-image',
    ref,
    icon: element,
  },
));

FileImageIcon.displayName = 'FileImageIcon';

export default FileImageIcon;
